import { render } from "./app-header-combobox-schoolyear.vue?vue&type=template&id=49dfe5d9"
import script from "./app-header-combobox-schoolyear.vue?vue&type=script&lang=js"
export * from "./app-header-combobox-schoolyear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__